export const blogCardQuery = `{
  blog {
    meta_description
    card_title
    read_duration
    image
    author {
      name
      avatar
    }
    category {
      name
      uid
    }
  }
}`;
